import axios from '../axiosInstance';

export const getBillingPackages = async () => {
    console.log('consultando')
    const response = await axios.get('/config-packages/billing');
    return response.data;
};

export const getPointOfSalePackages = async () => {
    const response = await axios.get('/config-packages/pointofsale');
    return response.data;
};

export const getPayRollsPackages = async () => {
    const response = await axios.get('/config-packages/payrolls');
    return response.data;
};